import { FC } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { Box, BoxProps, HStack } from '@chakra-ui/react';
import { IconName as SunshineIconName } from '@shinetools/sunshine-icons';
import { Color } from '@shinetools/suntheme';

import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

interface Props extends BoxProps {
  title: string;
  color: Color;
  backgroundColor: Color;
  icon: SunshineIconName;
  onVisibilityChange: (isVisible: boolean) => void;
  anchor: string;
}

/**
 * Form section used in invoice/quote creation form page
 */
const FormSection: FC<Props> = ({
  anchor,
  backgroundColor,
  children,
  color,
  icon,
  onVisibilityChange,
  title,
  ...props
}) => (
  <VisibilitySensor offset={{ top: -16 }} onChange={onVisibilityChange}>
    <Box id={anchor} paddingTop="space-80" {...props}>
      <HStack marginBottom="space-40" spacing="space-12">
        <SquircleIcon name={icon} />
        <Text fontWeight="weight-500" size="lg" variant="primary">
          {title}
        </Text>
      </HStack>

      {children}
    </Box>
  </VisibilitySensor>
);

export default FormSection;
